import {Injectable} from '@angular/core';

// Declare gTM dataLayer array.
declare global {
  interface Window {
    dataLayer: any [];
  }
}

@Injectable({
  providedIn: 'root'
})

export class GoogleTagManagerService {

  constructor() {
  }

  //push event to GTM
  pushEvent(event:any) {
    window.dataLayer.push(event);
  }
}
